// extracted by mini-css-extract-plugin
export default {"textarea":"MyTextarea_textarea__WljXQ"};